// extracted by mini-css-extract-plugin
export var wrapper = "team-compisition-list-module--wrapper--xDg0P";